import { Col, Row, Table, Tag } from "antd";
import { useTranslation } from "react-i18next";
import {
  MdOpenInNew,
  MdOutlineDeleteOutline,
  MdOutlineMail,
} from "react-icons/md";
import { useNavigate } from "react-router-dom";
import Pagination from "shared/components/Pagination";
import { NAME_SPACES } from "shared/locales/constants";
import { COLORS } from "shared/style/colors";
import { SCREENS } from "utils/constants";
import { isRemoteEmailTemplateIcon } from "utils/emailTemplateIcon";

function List({ data, count, setValues, skip }) {
  const navigate = useNavigate();
  const { t } = useTranslation(NAME_SPACES.PRIVATE.ADMIN.EMAIL_TEMPLATE);
  const LIST = t("LIST", { returnObjects: true });

  const columns = [
    {
      title: LIST.ICON,
      dataIndex: "icon",
      width: 60,
      render: (icon) => (
        <span className="email-template-list__icon-cell">
          {isRemoteEmailTemplateIcon(icon) ? (
            <img src={icon} alt="" className="email-template-list__icon-img" />
          ) : icon ? (
            icon
          ) : (
            <MdOutlineMail size={22} />
          )}
        </span>
      ),
    },
    {
      title: LIST.LABEL,
      dataIndex: "label",
    },
    {
      title: LIST.DESCRIPTION,
      dataIndex: "description",
      render: (text) => text || "-",
    },
    {
      title: LIST.SUBJECT,
      dataIndex: "subject",
      render: (text) => text || "-",
    },
    {
      title: LIST.STATUS,
      dataIndex: "active",
      render: (active) => (
        <Tag color={active ? "green" : "default"}>
          {active ? LIST.ACTIVE : LIST.INACTIVE}
        </Tag>
      ),
    },
    {
      title: LIST.ACTIONS,
      dataIndex: "id",
      align: "right",
      render: (id) => (
        <Row gutter={8} justify="end" align="center" wrap={false}>
          <Col
            onClick={() =>
              navigate(
                `${SCREENS.PRIVATE.ADMIN.EMAIL_TEMPLATES.DETAIL.path}/${id}`,
              )
            }
          >
            <MdOpenInNew size={24} color={COLORS.C_PRIMARY} />
          </Col>
          <Col
            onClick={() =>
              navigate(
                `${SCREENS.PRIVATE.ADMIN.EMAIL_TEMPLATES.DELETE.path}/${id}`,
              )
            }
          >
            <MdOutlineDeleteOutline size={24} color={COLORS.C_DANGER} />
          </Col>
        </Row>
      ),
    },
  ];

  return (
    <>
      <Table
        dataSource={data}
        className="table__wrapper"
        columns={columns}
        rowKey={"id"}
        pagination={false}
        scroll={{ x: true }}
      />
      <Pagination count={count} setValues={setValues} skip={skip} />
    </>
  );
}

export default List;
